<template>
<v-app>
  <v-content>
    <v-container>
      <v-row dense>
        <v-col>
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header class="py-2 title">検索条件</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form ref="form" v-model="valid">
                  <v-card flat>
                    <v-card-title class="py-0 subTitle">対象者</v-card-title>
                    <v-card-text class="py-0 pl-8">
                      <v-radio-group v-model="searchParams.searchBy" hide-details class="mt-0">
                        <v-radio value="dept" label="部門コード検索" />
                        <v-row dense style="padding-left: 34px;">
                          <v-col>
                            <v-text-field
                              v-model="searchParams.deptCode"
                              :hint="deptName"
                              persistent-hint
                              dense
                              outlined
                              placeholder="部門コードを入力して下さい"
                              :disabled="searchParams.searchBy !== 'dept'"
                              :rules="searchParams.searchBy === 'dept' ? [checkRequired] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <v-btn tile outlined color="primary" :disabled="searchParams.searchBy !== 'dept'" @click="showDeptModal">
                              部門コード照会
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-radio label="1st組織コード検索" value="honbu"></v-radio>
                        <v-row dense style="padding-left: 34px;">
                          <v-col>
                            <v-text-field
                              v-model="searchParams.honbuCode"
                              :hint="honbuName"
                              persistent-hint
                              dense
                              outlined
                              placeholder="1st組織コードを入力して下さい"
                              :disabled="searchParams.searchBy !== 'honbu'"
                              :rules="searchParams.searchBy === 'honbu' ? [checkRequired] : []">
                            </v-text-field>
                          </v-col>
                          <v-col>
                            <v-btn tile outlined color="primary" :disabled="searchParams.searchBy !== 'honbu'" @click="showHonbuModal">
                              1st組織コード照会
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-radio v-if="this.$store.state.readPermission === 0" class="pb-8" value="all" label="全社検索" />
                      </v-radio-group>
                    </v-card-text>

                    <v-card-title class="py-2 subTitle">対象年月</v-card-title>
                    <v-card-text class="py-0 pl-8">
                      <v-row dense>
                        <v-col cols="4">
                          <v-select
                            v-model="searchParams.targetPeriod"
                            :items="targetPeriodHeaders"
                            label="対象年月を選択"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-card-title class="py-2 subTitle">絞り込み対象</v-card-title>
                    <v-card-text class="py-0 pl-8">
                      <v-row>
                        <v-col class="form-row-label">
                          <label>回答有無</label>
                        </v-col>
                        <v-col>
                          <v-radio-group v-model="searchParams.answer" row hide-details class="mt-0 pt-0">
                            <v-radio v-for="(item, i) in answerItems" :key="i" :label="item.label" :value="item.value" class="form-row-item"></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="download()" :disabled="!valid">
                        <v-icon left>mdi-file-download-outline</v-icon>CSVダウンロード
                      </v-btn>
                      <v-btn color="primary" @click="search()" :disabled="!valid">
                        <v-icon left>mdi-magnify</v-icon>検索
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-expansion-panel-content>
              <div v-if="!panel" style="width: 100%; padding: 8px 0 8px 24px;">
                {{ searchParamsText }}
              </div>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row v-if="rows">
        <v-col>
          <v-data-table
            :headers="tableHeaders"
            :items="rows"
            :page.sync="currentPage"
            class="elevation-1"
            no-data-text="検索結果はありません"
            :footer-props="{
              'items-per-page-options': [10, 50, 100, -1],
            }"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <departmentModal ref="departmentModal" @department="selectedDepartment"></departmentModal>
  </v-content>
</v-app>
</template>

<script>
import departmentModal from '@/components/DepartmentList'
import Api from '@/api/methods'

export default {
  name: 'SurveyList',
  components: {
    departmentModal
  },
  beforeMount() {
    this.$store.commit('setTitle', '通勤定期・実費請求調査アンケート一覧');
    if (this.$store.state.token === null) {
      this.$router.push({
        name: 'Login',
        params: {
          next: 'SurveyList'
        }
      });
    }

  },
  data() {
    const targetPeriodHeaders = [
        {value: 202201,  text: "2022年1月"}
    ]
    return {
      valid: true,
      targetPeriodHeaders,
      searchParams: {
        format: '',
        searchBy: 'dept',
        deptCode: '',
        honbuCode: '',
        answer: -1,
        targetPeriod: targetPeriodHeaders[0].value,
      },
      answerItems: [
        { value: -1, label: '指定なし' },
        { value: 1, label: 'あり' },
        { value: 0, label: 'なし' },
      ],
    
      // search results
      tableHeaders: [
        { text: '所属', value: 'dept_name', sortable: false },
        { text: '氏名', value: 'user_name', sortable: false },
        { text: '在宅日数', value: 'day_count', sortable: false },
        { text: '通勤費請求方法', value: 'before_month_work_option', sortable: false },
      ],

      searchParamsText: '',
      deptName: '',
      honbuName: '',
      rows: null,
      panel: 0,
      currentPage:1,
    };
  },
  watch: {
    panel(val) {
      if (val !== 0) {
        // close
        const texts = []
          texts.push(`対象年月：${this.targetPeriodHeaders.find(item => item.value == this.searchParams.targetPeriod).text}`)
        if (this.searchParams.searchBy === 'dept') {
          texts.push(`部門コード検索：${this.searchParams.deptCode !== '' ? this.searchParams.deptCode : '未入力'}`)
        }
        if (this.searchParams.searchBy === 'honbu') {
          texts.push(`1st組織コード検索：${this.searchParams.honbuCode !== '' ? this.searchParams.honbuCode : '未入力'}`)
        }
        if (this.searchParams.searchBy === 'all') {
          this.searchParams.deptCode = ''
          this.searchParams.honbuCode = ''
          texts.push(`全社検索`)
        }
        if (this.searchParams.answer !== -1) {
          texts.push(`回答：${this.answerItems.find(item => item.value === this.searchParams.answer).label}`)
          if (this.searchParams.answer === 0){
            this.searchParams.beforeMonthWorkOption = '指定なし'
          }
        }
        this.searchParamsText = texts.join('／')
      } else {
        this.searchParamsText = ''
      }
    },
  },
 
  methods: {
    checkRequired(v) {
      if (!v) {
        return '必須です'
      }
      return true
    },
    
    showDeptModal() {
      this.$refs.departmentModal.setDepartment();
      this.$refs.departmentModal.showModal();
    },
    showHonbuModal() {
      this.$refs.departmentModal.setDivision();
      this.$refs.departmentModal.showModal();
    },
    selectedDepartment(department) {
      if (this.searchParams.searchBy === 'dept') {
        this.searchParams.deptCode = department.dept_code
        this.deptName = department.dept_name
      }
      if (this.searchParams.searchBy === 'honbu') {
        this.searchParams.honbuCode = department.dept_code
        this.honbuName = department.dept_name
      }
    },

    async search() {
      if (!this.$refs.form.validate()) return

      this.searchParams.format = 'json'
  
      const params = { ...this.searchParams }
      await Api.getworkingSurveyList(params)
      .then(res => {
        if (res.data.msg === "OK") {
          this.rows = res.data.rows
          this.panel = false
        } else {
          alert("検索に失敗しました。");
        }
      }).catch(e => {
        console.error(e);
        if(e.data.msg === "NG"){
          alert("検索に失敗しました。");
        }
      });
      this.currentPage = 1
    },

    async download() {
      if (!this.$refs.form.validate()) return
    
      this.searchParams.format = 'csv'
      const params = { ...this.searchParams }
      try {
        const res = await Api.getworkingSurveyList(params)
        const url = window.URL.createObjectURL(new Blob([res.data], {
          type: "text/csv"
        }));
        const link = document.createElement('a');
        document.body.appendChild(link);
        link.href = url;
        link.download = `通勤定期・実費請求調査アンケート一覧_${this.csvName}.csv`
        link.click();
        // Edge用にディレイを追加
        window.setTimeout(window.URL.revokeObjectURL, 100, url);
        document.body.removeChild(link);
      } catch (e) {
        console.error(e)
        if(e.data.msg === "NG"){
          alert('検索に失敗しました')
        }
      }
    },
  },

  computed: {
    csvName() {
      if (this.searchParams.searchBy === 'dept') {
        return this.deptName
      }else if(this.searchParams.searchBy === 'honbu'){
        return this.honbuName
      }else{
        return '全社'
      }
    },
  }
}
</script>

<style scoped>
.title {
  font-size: 20px;
}

.subTitle {
  font-size: 15px;
  font-weight: bold;
}

.result td:first-child {
  display: none;
}

.form-row-label {
  max-width: 235px;
}

.form-row-item {
  width: 120px;
}

.v-data-table td, .v-data-table th {
  white-space: nowrap;
  padding: 0 8px;
}

</style>
